<template>
  <form>
    <SurveyAnswerListItem v-for="answer in answers" :key="answer.id" :answer="answer" @select="handleSelect" />
  </form>
</template>

<script>
import SurveyAnswerListItem from './SurveyAnswerListItem.vue'

export default {
  name: 'SurveyAnswerList',
  components: {
    SurveyAnswerListItem
  },
  props: {
    answers: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleSelect(id) {
      this.$emit('selectAnswer', id)
    }
  }
}
</script>
